import React, {
  createContext,
  useContext,
  useRef,
  useState,
  useCallback,
  useMemo
} from 'react';
import PropTypes from 'prop-types';

const ResourceAllocationChartFocusContext = createContext();

export const useResourceAllocationChartFocusContext = () =>
  useContext(ResourceAllocationChartFocusContext);

export const ResourceAllocationChartFocusContextProvider = ({ children }) => {
  const [focusedRowUserId, setFocusedRowUserId] = useState(null);

  const userRowElementRef = useRef(null);
  const allocateResourceButtonRef = useRef(null);
  const headerLabelRef = useRef(null);

  const setFocusToAllocateResourceButton = useCallback(() => {
    if (allocateResourceButtonRef?.current) {
      allocateResourceButtonRef.current.focus();
    }
  }, []);

  const setFocusToHeader = useCallback(() => {
    if (headerLabelRef?.current) {
      headerLabelRef.current.focus();
    }
  }, []);

  const value = useMemo(
    () => ({
      focusedRowUserId,
      userRowElementRef,
      allocateResourceButtonRef,
      headerLabelRef,
      setFocusedRowUserId,
      setFocusToAllocateResourceButton,
      setFocusToHeader
    }),
    [
      setFocusToAllocateResourceButton,
      setFocusedRowUserId,
      setFocusToHeader,
      focusedRowUserId
    ]
  );

  return (
    <ResourceAllocationChartFocusContext.Provider value={value}>
      {children}
    </ResourceAllocationChartFocusContext.Provider>
  );
};

ResourceAllocationChartFocusContextProvider.propTypes = {
  children: PropTypes.node.isRequired
};
